import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AbilityService } from '@casl/angular';
import { UserService } from '@tw/services';
import { filter, map, take } from 'rxjs';
import {
  AppAbility,
  PermissionAction,
  PermissionSubject,
} from '../models/permissions';

export const permissionGuard: CanActivateFn = (route) => {
  const router = inject(Router);
  const abilityService = inject<AbilityService<AppAbility>>(AbilityService);
  const userService = inject(UserService);

  const {
    permissions,
  }: {
    permissions?: {
      subject: PermissionSubject;
      action: PermissionAction;
    }[];
  } = route.data;
  if (!permissions?.length) return true;

  return abilityService.ability$.pipe(
    filter(() => userService.isAbilityReady()),
    take(1),
    map((userAbilities) => {
      const matched = permissions.some((perm) => {
        const result = userAbilities.can(perm.action, perm.subject);
        return result;
      });

      if (!matched) {
        router.navigate(['/unauthorized']);
        return false;
      }

      return true;
    }),
  );
};
